import { Injectable } from '@angular/core';
import { AuthService } from "src/app/modules/auth/_services/auth.service";
import { SplashScreenService } from 'src/app/_metronic/partials/layout/splash-screen/splash-screen.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SessionUserService {

  constructor(
    private authService: AuthService,
    private splashScreenService: SplashScreenService,
    private tokenService: TokenStorageService,
    private localStorageService: LocalStorageService,
    private router: Router
  ) {}

  verificarSesionUsuario(): void {
    const userSession = this.localStorageService.getUserSession();
    let cMaestra: boolean | null = null;
    let sesionId: string | null = null;
    if (userSession) {
      cMaestra = userSession.cMaestra;
      sesionId = userSession.id;
    }
    const usuarioId = userSession?.usuarioId;
    if (usuarioId && !cMaestra && sesionId) {
      this.authService.verificarSesion(usuarioId, sesionId).subscribe({
        next: () => {
          // Sesión activa, todo ok
        },
        error: () => {
          this.splashScreenService.hide();
          this.tokenService.signOut();
          this.localStorageService.signOut();
          Swal.fire({
            icon: 'warning',
            title: 'Sesión cerrada',
            text: 'Tu sesión ha sido cerrada. Por favor, inicia sesión nuevamente.',
          }).then(() => {
            this.router.navigate(['/auth/login']);
          });
        }
      });
    }
  }
}
